export default "__VITE_ASSET__CbExiThb__"